import type {
  BreadcrumbLinkProps,
  BreadcrumbsProps,
} from '@/components/Breadcrumbs/types';
import type { CategoryHeader } from '@/utils/pages/api';
import { LIBRARY_ROOTS } from '@/constants/library-roots';
import { getBreadcrumbChildren } from './get-breadcrumb-children';
import { getBreadcrumbParents } from './get-breadcrumb-parents';
import { getCurrentBreadcrumb } from './get-current-breadcrumb';

export const MUSIC_BREADCRUMB_ROOT: BreadcrumbLinkProps = {
  id: '0',
  label: 'Music',
  slug: '/music',
  relative_url: LIBRARY_ROOTS.MUSIC,
};

export const getMusicBreadcrumbs = ({
  pageData,
}: {
  pageData: CategoryHeader;
}): BreadcrumbsProps => {
  const current = getCurrentBreadcrumb({ data: pageData });

  const previous = [MUSIC_BREADCRUMB_ROOT];

  const canonicalParentsLinks = getBreadcrumbParents({
    data: pageData.breadcrumb_parents,
  });

  if (canonicalParentsLinks) {
    previous.push(...canonicalParentsLinks);
  }

  const result: BreadcrumbsProps = {
    current,
    previous,
    next: getBreadcrumbChildren({ taxonomy: pageData.taxonomy }),
    assetType: 'music',
  };

  return result;
};
